import React, { useEffect, useState } from 'react'

// redux
import { connect } from 'react-redux'

// bootstrap
import { Modal, Spinner } from 'react-bootstrap'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// form fields
import AppFormikInput from 'utlis/helpers/forms/AppFormikInput'
import AppFormikTextarea from 'utlis/helpers/forms/AppFormikTextarea';

// api
import { sendPaymentLinkApi } from 'utlis/Apis/Cart_API';

// toast
import { toast } from 'react-toastify'

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED
} from 'utlis/AppMessages/AppMessages'

function SendPaymentLinkModal(props) {
    // props
    const {
        authState,
        currentOrderId,

        modalVisibility,
        closeModal,

        userEmail,
    } = props

    // states
    const [btnLoading, setBtnLoading] = useState(false)
    const [btnDisable, setBtnDisable] = useState(false)

    // initial form values
    const initialFormValues = {
        to: userEmail ?? "",
        message: "",
        // link: "",
    }

    // handle form validations
    const formValidationSchema = Yup.object({
        to: Yup.string(),
        message: Yup.string(),
        // link: Yup.string().required('This field is required'),
    })

    // handle form submmision
    const onFormSubmit = values => {
        if (values) {
            // loading
            setBtnLoading(true)
            setBtnDisable(true)

            // data required
            const requiredData = {
                order_id: currentOrderId,
                message: values.message
            }

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            // network request
            sendPaymentLinkApi(headers, requiredData).then(res => {
                const resData = res.data

                // loading
                setBtnLoading(false)
                setBtnDisable(false)

                // if success
                if (resData.success) {
                    closeModal && closeModal() // closing the modal

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success(resData.message, {
                        autoClose: 2500
                    });
                }

                // if error
                if (resData.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500
                    });
                }

            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} sendPaymentLinkApi `, err.message);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // loading
                        setBtnLoading(false)
                        setBtnDisable(false)
                    },
                });
            })
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
    })

    // setting field value
    useEffect(() => {
        if (userEmail) {
            formik.setFieldValue("to", userEmail)
        }
    }, [userEmail])

    return (
        <Modal
            show={modalVisibility}
            onHide={closeModal}
            centered
            size={"lg"}
            className="st-info-modal">
            <Modal.Body className="st-modal">
                {/* close icon */}
                <div className="app-modal-content modal_compelte-payment position-relative pt-0" style={{ minHeight: 'auto' }}>
                    <button
                        className="close-icon position-absolute st-round-btn st-btn-sm st-btn-white d-flex align-items-center justify-content-center"
                        onClick={closeModal}
                        style={{ top: 0, right: 0 }}>
                        <FeatherIcon
                            icon="x"
                            size="20"
                            className="icon position-relative" />
                    </button>


                    {/* head */}
                    <div className="app-modal-title-wrapper mb-3">
                        <p className="app-modal-title mb-2">Send Payment Link</p>
                        <p className="desc">Send a payment link so that the user can complete the order.</p>
                    </div>

                    <div className="form">
                        <form onSubmit={formik.handleSubmit}
                            noValidate
                            autoComplete="off">
                            <AppFormikInput
                                formik={formik} // formik object
                                stFormClass={"disabled"} // class name for main wrapper
                                labelName={"To"} // label name
                                isRequired={false} // is this field is required or not to show the red star sign
                                placeholder={"To"} // placeholder for the input
                                formikFieldName={"to"} // important: formik value name for the input
                                disabled={true}
                            />

                            {/* textarea */}
                            {/* <AppFormikTextarea
                                formik={formik} // formik object
                                stFormClass={""} // class name for main wrapper
                                labelName={"Link"} // label name
                                isRequired={true} // is this field is required or not to show the red star sign
                                placeholder={"Link"} // placeholder for the input
                                textareaRows={"2"} // rows for textarea
                                formikFieldName={"link"} // important: formik value name for the input
                            /> */}

                            {/* textarea */}
                            <AppFormikTextarea
                                formik={formik} // formik object
                                stFormClass={""} // class name for main wrapper
                                labelName={"Message"} // label name
                                // isRequired={true} // is this field is required or not to show the red star sign
                                placeholder={"Message"} // placeholder for the input
                                textareaRows={"3"} // rows for textarea
                                formikFieldName={"message"} // important: formik value name for the input
                            />

                            <div className="btns mt-3 mt-lg-4" style={{ width: 200 }}>
                                <button
                                    type="submit"
                                    className={`st-btn st-btn-primary text-capitalize w-100 ${btnDisable ? "disabled" : ""}`}
                                    disabled={btnDisable}
                                >
                                    {
                                        btnLoading ? (
                                            <Spinner size="sm" animation="border" />
                                        ) : (
                                            "Send Link"
                                        )
                                    }
                                </button>
                            </div>
                        </form>
                    </div>

                </div>
            </Modal.Body>
        </Modal>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(SendPaymentLinkModal)